import {cloneObject, uuid} from "../common/utils";
import {
  TransitData,
  TransitDeclaration,
  TransitInspectionStatus,
  TransitPhase,
  TransitStatusUpdate,
  TransitSummary
} from '@portbase/bezoekschip-service-typescriptmodels';
import moment, {now} from "moment";
import {Transit} from "../transit/transit.utils";

const direct = moment(now()).toISOString();

export const simplifiedScheduled = <Transit>{
  summary: {
    crn: "DANGEROUS_GOODS",
    declarantShortName: "EIMSKIPBRR",
    containerNumber: "RVWI0000001",
    consignmentNumbers: [],
    declarantFullName: "Eimskip Nederland B.V.",
    departureOfficeCode: "NL000510",
    departureOfficeName: "NL000510",
    destinationsOfficeCode: "NL000510",
    destinationsOfficeName: "NL000510",
    typeCode: "T1",
    sendDate: "2022-07-13T22:00:00Z",
    transportTerm: "PT216H",
    departureModeOfTransport: "ROAD_TRANSPORT",
    inspectionStatus: {
      type: "A3"
    },
    cancelInitiatedByCustoms: false,
    hasMultipleHouseConsignments: false,
    isInfoDeclared: false,
    isReleased: false,
    sendOnAta: false
  },
  hidden: false,
  isContainerDeclaration: true,
  isNewTransitDeclaration: false,
  selected: false,
  declaration: {
    crn: "DANGEROUS_GOODS",
    declarantShortName: "EIMSKIPBRR",
    data: {
      containerNumber: "RVWI0000001",
      goodsItems: [
        {
          description: "SLAC 274 PC FISHING EQUIPMENT Ships stores in transhipment to final destination F/V Jonas at Mombasa Fisheries, Jetty, Liwatoni Fishing equipment",
          previousDocument: {
            type: {
              code: "N705",
              description: "whatever"
            },
            documentNumber: "EIMUSKO130VESW009"
          },
          packageType: {
            code: "PK",
            name: "Package",
            bulk: false
          },
          marksAndNumbers: "Package",
          weight: 15000.0,
          numberOfPackages: 274
        }
      ],
      itinerary: [],
      type: {
        code: "T1",
        description: "T1"
      },
      countryOfExport: {
        code: "IS",
        name: "IS"
      },
      departureOffice: {
        name: "NL000510",
        unCode: "NL000510"
      },
      departureTransport: {
        modeOfTransport: "ROAD_TRANSPORT",
        nationality: {
          code: "NL",
          name: "NL"
        },
        reference: "TRUCK"
      },
      countryOfDestination: {
        code: "KE",
        name: "KE"
      },
      destinationsOffice: {
        name: "NL000510",
        unCode: "NL000510"
      },
      consignee: {
        eoriNumber: "NL807407343",
        name: "APM TERMINAL",
        address: "COLORADOWEG  50",
        zipCode: "3199 LA",
        city: "ROTTERDAM",
        countryCode: "NL"
      },
      transitOffices: [],
      guarantees: [
        {
          type: {
            code: "1",
            description: "Iets met een 1 erin"
          },
          customsValue: {
            amount: 1234.55,
            currency: {
              unCode: "EUR",
              description: "Euris"
            }
          },
          country: {
            code: "NL",
            name: "Nederland"
          },
          guaranteeReferenceNumber: "GRUESOME",
          accessCode: "1244"
        }
      ],
      seals: [
        "939939"
      ],
      placeOfLoading: "3195 KN 15",
      authorizedLocation: "3195 KN 15",
      representative: "Danny van der Walle Goncalves",
      transportTerm: "PT216H"
    },
    status: {
      sendOnAta: false,
      sendDate: "2022-07-13T22:00:00Z",
      cancelInitiatedByCustoms: false,
      inspectionStatus: {
        type: "A3"
      }
    },
    timestamp: "2021-08-17T11:21:44.948Z"
  }
};

export const simplifiedOnAta = <Transit>{
  summary: {
    crn: "ON_ATA_TEST",
    declarantShortName: "EIMSKIPBRR",
    containerNumber: "RVWI0000002",
    consignmentNumbers: [],
    declarantFullName: "Eimskip Nederland B.V.",
    dischargeTerminalCode: "52090469",
    dischargeTerminalName: "Holland Amerikakade",
    departureOfficeCode: "NL000510",
    departureOfficeName: "NL000510",
    destinationsOfficeCode: "NL000510",
    destinationsOfficeName: "NL000510",
    typeCode: "T1",
    transportTerm: "PT216H",
    departureModeOfTransport: "ROAD_TRANSPORT",
    inspectionStatus: {
      type: "A3"
    },
    cancelInitiatedByCustoms: false,
    hasMultipleHouseConsignments: false,
    isInfoDeclared: false,
    isReleased: false,
    sendOnAta: true
  },
  hidden: false,
  isContainerDeclaration: true,
  isNewTransitDeclaration: false,
  selected: false,
  declaration: {
    declarantShortName: "EIMSKIPBRR",
    data: {
      containerNumber: "RVWI0000002",
      dischargeTerminal: {
        terminalName: "Holland Amerikakade",
        terminalCode: "52090469"
      },
      emailAddressMrnToTerminal: "bladieblah@blah.nl",
      emailAddressesMrnToTerminalForCopy: ["typies@blah.nl"],
      emailAddressContainerInTransit: "hot@hotmail.com",
      emailAddressesContainerInTransitForCopy: ["bladieblah@blah.nl", "hot@hotmail.com"],
      emailAddressesForExpiryReminder: ["emailAddressesForExpiryReminder@blah.nl", "emailAddressesForExpiryReminder@hotmail.com"],
      expiryReminderNumberOfDaysBefore: 2,
      goodsItems: [
        {
          description: "SLAC 274 PC FISHING EQUIPMENT Ships stores in transhipment to final destination F/V Jonas at Mombasa Fisheries, Jetty, Liwatoni Fishing equipment",
          previousDocument: {
            type: {
              code: "N705",
              description: "oather"
            },
            documentNumber: "EIMUSKO130VESW009"
          },
          packageType: {
            code: "PK",
            name: "Package",
            bulk: false
          },
          marksAndNumbers: "Package",
          weight: 15000.0,
          numberOfPackages: 274
        }
      ],
      itinerary: [],
      type: {
        code: "T1",
        description: "T1"
      },
      countryOfExport: {
        code: "IS",
        name: "IS"
      },
      departureOffice: {
        name: "NL000510",
        unCode: "NL000510"
      },
      departureTransport: {
        modeOfTransport: "ROAD_TRANSPORT",
        nationality: {
          code: "NL",
          name: "NL"
        },
        reference: "TRUCK"
      },
      countryOfDestination: {
        code: "KE",
        name: "KE"
      },
      destinationsOffice: {
        name: "NL000510",
        unCode: "NL000510"
      },
      consignee: {
        eoriNumber: "NL807407343",
        name: "APM TERMINAL",
        address: "COLORADOWEG  50",
        zipCode: "3199 LA",
        city: "ROTTERDAM",
        countryCode: "NL"
      },
      transitOffices: [{
        name: "NL000511",
        unCode: "NL000511"
      }, {
        name: "NL000512",
        unCode: "NL000512"
      }, {
        name: "NL000513",
        unCode: "NL000513"
      }],
      guarantees: [{
        type: {
          code: "1",
          description: "Iets met een 1 erin"
        },
        customsValue: {
          amount: 123.45,
          currency: {
            unCode: "EUR",
            description: "Euris"
          }
        },
        country: {
          code: "NL",
          name: "Nederland"
        },
        guaranteeReferenceNumber: "GRUESOME",
        accessCode: "1244"
      }],
      seals: [
        "dichtjonghu"
      ],
      placeOfLoading: "3195 KN 15",
      authorizedLocation: "3195 KN 15",
      representative: "Danny van der Walle Goncalves",
      transportTerm: "PT216H"
    },
    status: {
      sendOnAta: true,
      cancelInitiatedByCustoms: false,
      inspectionStatus: {
        type: "A3"
      }
    },
    crn: "ON_ATA_TEST",
    timestamp: "2021-08-17T11:21:44.948Z"
  }
};

export const simplifiedDirectly = <Transit>{
  summary: {
    crn: "DIRECTTEST",
    declarantShortName: "EIMSKIPBRR",
    containerNumber: "RVWI0000003",
    consignmentNumbers: [],
    declarantFullName: "Eimskip Nederland B.V.",
    dischargeTerminalCode: "52090469",
    dischargeTerminalName: "Holland Amerikakade",
    departureOfficeCode: "NL000510",
    departureOfficeName: "NL000510",
    destinationsOfficeCode: "NL000510",
    destinationsOfficeName: "NL000510",
    typeCode: "T1",
    sendDate: direct,
    transportTerm: "PT216H",
    departureModeOfTransport: "ROAD_TRANSPORT",
    inspectionStatus: {
      type: "A3"
    },
    cancelInitiatedByCustoms: false,
    hasMultipleHouseConsignments: false,
    isInfoDeclared: false,
    isReleased: false,
    sendOnAta: false
  },
  hidden: false,
  isContainerDeclaration: true,
  isNewTransitDeclaration: false,
  selected: false,
  declaration: {
    declarantShortName: "EIMSKIPBRR",
    data: {
      containerNumber: "RVWI0000003",
      dischargeTerminal: {
        terminalName: "Holland Amerikakade",
        terminalCode: "52090469"
      },
      emailAddressMrnToTerminal: "bladieblah@blah.nl",
      emailAddressesMrnToTerminalForCopy: ["typies@blah.nl"],
      emailAddressContainerInTransit: "hot@hotmail.com",
      emailAddressesContainerInTransitForCopy: ["bladieblah@blah.nl", "hot@hotmail.com"],
      emailAddressesForExpiryReminder: ["emailAddressesForExpiryReminder@blah.nl", "emailAddressesForExpiryReminder@hotmail.com"],
      expiryReminderNumberOfDaysBefore: 2,
      goodsItems: [
        {
          description: "SLAC 274 PC FISHING EQUIPMENT Ships stores in transhipment to final destination F/V Jonas at Mombasa Fisheries, Jetty, Liwatoni Fishing equipment",
          previousDocument: {
            type: {
              code: "N705",
              description: "oather"
            },
            documentNumber: "EIMUSKO130VESW009"
          },
          packageType: {
            code: "PK",
            name: "Package",
            bulk: false
          },
          marksAndNumbers: "Package",
          weight: 15000.0,
          numberOfPackages: 274
        }
      ],
      itinerary: [],
      type: {
        code: "T1",
        description: "T1"
      },
      countryOfExport: {
        code: "IS",
        name: "IS"
      },
      departureOffice: {
        name: "NL000510",
        unCode: "NL000510"
      },
      departureTransport: {
        modeOfTransport: "ROAD_TRANSPORT",
        nationality: {
          code: "NL",
          name: "NL"
        },
        reference: "TRUCK"
      },
      countryOfDestination: {
        code: "KE",
        name: "KE"
      },
      destinationsOffice: {
        name: "NL000510",
        unCode: "NL000510"
      },
      consignee: {
        eoriNumber: "NL807407343",
        name: "APM TERMINAL",
        address: "COLORADOWEG  50",
        zipCode: "3199 LA",
        city: "ROTTERDAM",
        countryCode: "NL"
      },
      transitOffices: [{
        name: "NL000511",
        unCode: "NL000511"
      }, {
        name: "NL000512",
        unCode: "NL000512"
      }, {
        name: "NL000513",
        unCode: "NL000513"
      }],
      guarantees: [{
        type: {
          code: "1",
          description: "Iets met een 1 erin"
        },
        customsValue: {
          amount: 123.45,
          currency: {
            unCode: "EUR",
            description: "Euris"
          }
        },
        country: {
          code: "NL",
          name: "Nederland"
        },
        guaranteeReferenceNumber: "GRUESOME",
        accessCode: "1244"
      }],
      seals: [
        "dichtjonghu"
      ],
      placeOfLoading: "3195 KN 15",
      authorizedLocation: "3195 KN 15",
      representative: "Danny van der Walle Goncalves",
      transportTerm: "PT216H"
    },
    status: {
      sendOnAta: false,
      sendDate: direct,
      cancelInitiatedByCustoms: false,
      inspectionStatus: {
        type: "A3"
      }
    },
    crn: "DIRECTTEST",
    timestamp: "2021-08-17T11:21:44.948Z"
  }
};

export const transitWithCrn = <Transit>{
  summary: {
    crn: "DANGEROUS_GOODS",
    declarantShortName: "EIMSKIPBRR",
    containerNumber: "TEST0608439",
    consignmentNumbers: [],
    declarantFullName: "Eimskip Nederland B.V.",
    departureOfficeCode: "NL000510",
    departureOfficeName: "NL000510",
    destinationsOfficeCode: "NL000510",
    destinationsOfficeName: "NL000510",
    typeCode: "T1",
    sendDate: "2021-08-17T00:00:00Z",
    transportTerm: "PT216H",
    departureModeOfTransport: "ROAD_TRANSPORT",
    inspectionStatus: {
      type: "A3"
    },
    cancelInitiatedByCustoms: false,
    hasMultipleHouseConsignments: false,
    isInfoDeclared: false,
    isReleased: false,
    sendOnAta: false
  },
  hidden: false,
  isContainerDeclaration: true,
  isNewTransitDeclaration: false,
  selected: false,
  declaration: {
    crn: "DANGEROUS_GOODS",
    declarantShortName: "EIMSKIPBRR",
    data: {
      containerNumber: "TEST0608439",
      goodsItems: [
        {
          description: "SLAC 274 PC FISHING EQUIPMENT Ships stores in transhipment to final destination F/V Jonas at Mombasa Fisheries, Jetty, Liwatoni Fishing equipment",
          previousDocument: {
            type: {
              code: "N705",
              description: "whatever"
            },
            documentNumber: "EIMUSKO130VESW009"
          },
          packageType: {
            code: "PK",
            name: "Package",
            bulk: false
          },
          marksAndNumbers: "Package",
          weight: 15000.0,
          numberOfPackages: 274
        }
      ],
      itinerary: [],
      type: {
        code: "T1",
        description: "T1"
      },
      countryOfExport: {
        code: "IS",
        name: "IS"
      },
      departureOffice: {
        name: "NL000510",
        unCode: "NL000510"
      },
      departureTransport: {
        modeOfTransport: "ROAD_TRANSPORT",
        nationality: {
          code: "NL",
          name: "NL"
        },
        reference: "TRUCK"
      },
      countryOfDestination: {
        code: "KE",
        name: "KE"
      },
      destinationsOffice: {
        name: "NL000510",
        unCode: "NL000510"
      },
      consignee: {
        eoriNumber: "NL807407343",
        name: "APM TERMINAL",
        address: "COLORADOWEG  50",
        zipCode: "3199 LA",
        city: "ROTTERDAM",
        countryCode: "NL"
      },
      transitOffices: [],
      guarantees: [
        {
          type: {
            code: "1",
            description: "Iets met een 1 erin"
          },
          customsValue: {
            amount: 1234.55,
            currency: {
              unCode: "EUR",
              description: "Euris"
            }
          },
          country: {
            code: "NL",
            name: "Nederland"
          },
          guaranteeReferenceNumber: "GRUESOME",
          accessCode: "1244"
        }
      ],
      seals: [
        "939939"
      ],
      placeOfLoading: "3195 KN 15",
      authorizedLocation: "3195 KN 15",
      representative: "Danny van der Walle Goncalves",
      transportTerm: "PT216H"
    },
    status: {
      sendOnAta: false,
      sendDate: "2021-08-17T00:00:00Z",
      cancelInitiatedByCustoms: false,
      inspectionStatus: {
        type: "A3"
      }
    },
    timestamp: "2021-08-17T11:21:44.948Z"
  }
};

export const transitWithoutCrn = <Transit>{
  summary: {
    declarantShortName: "EIMSKIPBRR",
    containerNumber: "MSKU0608439",
    consignmentNumbers: [],
    declarantFullName: "Eimskip Nederland B.V.",
    dischargeTerminalCode: "52090469",
    dischargeTerminalName: "Holland Amerikakade",
    departureOfficeCode: "NL000510",
    departureOfficeName: "NL000510",
    destinationsOfficeCode: "NL000510",
    destinationsOfficeName: "NL000510",
    carrierRemarks: "Dit is een transit aangifte die een enorm lange tekst bevat. Het zou nog steeds goed in de tooltip moeten tonen in het overview scherm",
    typeCode: "T1",
    sendDate: "2021-08-17T00:00:00Z",
    transportTerm: "PT216H",
    departureModeOfTransport: "ROAD_TRANSPORT",
    inspectionStatus: {
      type: "A3"
    },
    cancelInitiatedByCustoms: false,
    hasMultipleHouseConsignments: false,
    isInfoDeclared: false,
    isReleased: false,
    sendOnAta: false
  },
  hidden: false,
  isContainerDeclaration: true,
  isNewTransitDeclaration: false,
  selected: false,
  declaration: {
    declarantShortName: "EIMSKIPBRR",
    data: {
      containerNumber: "MSKU0608439",
      dischargeTerminal: {
        terminalName: "Holland Amerikakade",
        terminalCode: "52090469"
      },
      emailAddressMrnToTerminal: "bladieblah@blah.nl",
      emailAddressesMrnToTerminalForCopy: ["typies@blah.nl"],
      emailAddressContainerInTransit: "hot@hotmail.com",
      emailAddressesContainerInTransitForCopy: ["bladieblah@blah.nl", "hot@hotmail.com"],
      emailAddressesForExpiryReminder: ["emailAddressesForExpiryReminder@blah.nl", "emailAddressesForExpiryReminder@hotmail.com"],
      expiryReminderNumberOfDaysBefore: 2,
      goodsItems: [
        {
          description: "SLAC 274 PC FISHING EQUIPMENT Ships stores in transhipment to final destination F/V Jonas at Mombasa Fisheries, Jetty, Liwatoni Fishing equipment",
          previousDocument: {
            type: {
              code: "N705",
              description: "oather"
            },
            documentNumber: "EIMUSKO130VESW009"
          },
          packageType: {
            code: "PK",
            name: "Package",
            bulk: false
          },
          marksAndNumbers: "Package",
          weight: 15000.0,
          numberOfPackages: 274
        }
      ],
      itinerary: [],
      type: {
        code: "T1",
        description: "T1"
      },
      countryOfExport: {
        code: "IS",
        name: "IS"
      },
      departureOffice: {
        name: "NL000510",
        unCode: "NL000510"
      },
      departureTransport: {
        modeOfTransport: "ROAD_TRANSPORT",
        nationality: {
          code: "NL",
          name: "NL"
        },
        reference: "TRUCK"
      },
      countryOfDestination: {
        code: "KE",
        name: "KE"
      },
      destinationsOffice: {
        name: "NL000510",
        unCode: "NL000510"
      },
      consignee: {
        eoriNumber: "NL807407343",
        name: "APM TERMINAL",
        address: "COLORADOWEG  50",
        zipCode: "3199 LA",
        city: "ROTTERDAM",
        countryCode: "NL"
      },
      transitOffices: [{
        name: "NL000511",
        unCode: "NL000511"
      }, {
        name: "NL000512",
        unCode: "NL000512"
      }, {
        name: "NL000513",
        unCode: "NL000513"
      }],
      guarantees: [{
        type: {
          code: "1",
          description: "Iets met een 1 erin"
        },
        customsValue: {
          amount: 123.45,
          currency: {
            unCode: "EUR",
            description: "Euris"
          }
        },
        country: {
          code: "NL",
          name: "Nederland"
        },
        guaranteeReferenceNumber: "GRUESOME",
        accessCode: "1244"
      }],
      seals: [
        "dichtjonghu"
      ],
      placeOfLoading: "3195 KN 15",
      authorizedLocation: "3195 KN 15",
      representative: "Danny van der Walle Goncalves",
      transportTerm: "PT216H",
      carrierRemarks: "Dit is een transit aangifte die een enorm lange tekst bevat. Het zou nog steeds goed in de tooltip moeten tonen in het overview scherm"
    },
    status: {
      sendOnAta: false,
      sendDate: "2021-08-17T00:00:00Z",
      cancelInitiatedByCustoms: false,
      inspectionStatus: {
        type: "A3"
      }
    },
    timestamp: "2021-08-17T11:21:44.948Z"
  }
};

export const transitDepartureTransportModeNotSpecified = <Transit>{
  summary: {
    declarantShortName: "EIMSKIPBRR",
    containerNumber: "MSKU0608449",
    consignmentNumbers: [],
    declarantFullName: "Eimskip Nederland B.V.",
    dischargeTerminalCode: "52090469",
    dischargeTerminalName: "Holland Amerikakade",
    departureOfficeCode: "NL000510",
    departureOfficeName: "NL000510",
    destinationsOfficeCode: "NL000510",
    destinationsOfficeName: "NL000510",
    typeCode: "T1",
    sendDate: "2021-08-17T00:00:00Z",
    transportTerm: "PT216H",
    departureModeOfTransport: "NOT_SPECIFIED",
    inspectionStatus: {
      type: "A3"
    },
    cancelInitiatedByCustoms: false,
    hasMultipleHouseConsignments: false,
    isInfoDeclared: false,
    isReleased: false,
    sendOnAta: false
  },
  hidden: false,
  isContainerDeclaration: true,
  isNewTransitDeclaration: false,
  selected: false,
  declaration: {
    declarantShortName: "EIMSKIPBRR",
    data: {
      containerNumber: "MSKU0608449",
      dischargeTerminal: {
        terminalName: "Holland Amerikakade",
        terminalCode: "52090469"
      },
      emailAddressMrnToTerminal: "bladieblah@blah.nl",
      emailAddressesMrnToTerminalForCopy: ["typies@blah.nl"],
      emailAddressContainerInTransit: "hot@hotmail.com",
      emailAddressesContainerInTransitForCopy: ["bladieblah@blah.nl", "hot@hotmail.com"],
      emailAddressesForExpiryReminder: ["emailAddressesForExpiryReminder@blah.nl", "emailAddressesForExpiryReminder@hotmail.com"],
      expiryReminderNumberOfDaysBefore: 2,
      goodsItems: [
        {
          description: "SLAC 274 PC FISHING EQUIPMENT Ships stores in transhipment to final destination F/V Jonas at Mombasa Fisheries, Jetty, Liwatoni Fishing equipment",
          previousDocument: {
            type: {
              code: "N705",
              description: "oather"
            },
            documentNumber: "EIMUSKO130VESW009"
          },
          packageType: {
            code: "PK",
            name: "Package",
            bulk: false
          },
          marksAndNumbers: "Package",
          weight: 15000.0,
          numberOfPackages: 274
        }
      ],
      itinerary: [],
      type: {
        code: "T1",
        description: "T1"
      },
      countryOfExport: {
        code: "IS",
        name: "IS"
      },
      departureOffice: {
        name: "NL000510",
        unCode: "NL000510"
      },
      departureTransport: {
        modeOfTransport: "NOT_SPECIFIED",
        nationality: {
          code: "NL",
          name: "NL"
        },
        reference: "TRUCK"
      },
      countryOfDestination: {
        code: "KE",
        name: "KE"
      },
      destinationsOffice: {
        name: "NL000510",
        unCode: "NL000510"
      },
      consignee: {
        eoriNumber: "NL807407343",
        name: "APM TERMINAL",
        address: "COLORADOWEG  50",
        zipCode: "3199 LA",
        city: "ROTTERDAM",
        countryCode: "NL"
      },
      transitOffices: [{
        name: "NL000511",
        unCode: "NL000511"
      }, {
        name: "NL000512",
        unCode: "NL000512"
      }, {
        name: "NL000513",
        unCode: "NL000513"
      }],
      guarantees: [{
        type: {
          code: "1",
          description: "Iets met een 1 erin"
        },
        customsValue: {
          amount: 123.45,
          currency: {
            unCode: "EUR",
            description: "Euris"
          }
        },
        country: {
          code: "NL",
          name: "Nederland"
        },
        guaranteeReferenceNumber: "GRUESOME",
        accessCode: "1244"
      }],
      seals: [
        "dichtjonghu"
      ],
      placeOfLoading: "3195 KN 15",
      authorizedLocation: "3195 KN 15",
      representative: "Danny van der Walle Goncalves",
      transportTerm: "PT216H"
    },
    status: {
      sendOnAta: false,
      sendDate: "2021-08-17T00:00:00Z",
      cancelInitiatedByCustoms: false,
      inspectionStatus: {
        type: "A3"
      }
    },
    timestamp: "2021-08-17T11:21:44.948Z"
  }
};

export const transitCancelledAcceptedFound = <Transit>{
  summary: {
    declarantShortName: "EIMSKIPBRR",
    containerNumber: "MSKU0608450",
    consignmentNumbers: [],
    declarantFullName: "Eimskip Nederland B.V.",
    dischargeTerminalCode: "52090469",
    dischargeTerminalName: "Holland Amerikakade",
    departureOfficeCode: "NL000510",
    departureOfficeName: "NL000510",
    destinationsOfficeCode: "NL000510",
    destinationsOfficeName: "NL000510",
    typeCode: "T1",
    sendDate: "2021-08-17T00:00:00Z",
    transportTerm: "PT216H",
    departureModeOfTransport: "NOT_SPECIFIED",
    inspectionStatus: {
      type: "A3"
    },
    cancelInitiatedByCustoms: false,
    hasMultipleHouseConsignments: false,
    isInfoDeclared: false,
    isReleased: false,
    sendOnAta: false
  },
  hidden: false,
  isContainerDeclaration: true,
  isNewTransitDeclaration: false,
  selected: false,
  declaration: {
    declarantShortName: "EIMSKIPBRR",
    data: {
      containerNumber: "MSKU0608450",
      dischargeTerminal: {
        terminalName: "Holland Amerikakade",
        terminalCode: "52090469"
      },
      emailAddressMrnToTerminal: "bladieblah@blah.nl",
      emailAddressesMrnToTerminalForCopy: ["typies@blah.nl"],
      emailAddressContainerInTransit: "hot@hotmail.com",
      emailAddressesContainerInTransitForCopy: ["bladieblah@blah.nl", "hot@hotmail.com"],
      emailAddressesForExpiryReminder: ["emailAddressesForExpiryReminder@blah.nl", "emailAddressesForExpiryReminder@hotmail.com"],
      expiryReminderNumberOfDaysBefore: 2,
      goodsItems: [
        {
          description: "SLAC 274 PC FISHING EQUIPMENT Ships stores in transhipment to final destination F/V Jonas at Mombasa Fisheries, Jetty, Liwatoni Fishing equipment",
          previousDocument: {
            type: {
              code: "N705",
              description: "oather"
            },
            documentNumber: "EIMUSKO130VESW009"
          },
          packageType: {
            code: "PK",
            name: "Package",
            bulk: false
          },
          marksAndNumbers: "Package",
          weight: 15000.0,
          numberOfPackages: 274
        }
      ],
      itinerary: [],
      type: {
        code: "T1",
        description: "T1"
      },
      countryOfExport: {
        code: "IS",
        name: "IS"
      },
      departureOffice: {
        name: "NL000510",
        unCode: "NL000510"
      },
      departureTransport: {
        modeOfTransport: "NOT_SPECIFIED",
        nationality: {
          code: "NL",
          name: "NL"
        },
        reference: "TRUCK"
      },
      countryOfDestination: {
        code: "KE",
        name: "KE"
      },
      destinationsOffice: {
        name: "NL000510",
        unCode: "NL000510"
      },
      consignee: {
        eoriNumber: "NL807407343",
        name: "APM TERMINAL",
        address: "COLORADOWEG  50",
        zipCode: "3199 LA",
        city: "ROTTERDAM",
        countryCode: "NL"
      },
      transitOffices: [{
        name: "NL000511",
        unCode: "NL000511"
      }, {
        name: "NL000512",
        unCode: "NL000512"
      }, {
        name: "NL000513",
        unCode: "NL000513"
      }],
      guarantees: [{
        type: {
          code: "1",
          description: "Iets met een 1 erin"
        },
        customsValue: {
          amount: 123.45,
          currency: {
            unCode: "EUR",
            description: "Euris"
          }
        },
        country: {
          code: "NL",
          name: "Nederland"
        },
        guaranteeReferenceNumber: "GRUESOME",
        accessCode: "1244"
      }],
      seals: [
        "dichtjonghu"
      ],
      placeOfLoading: "3195 KN 15",
      authorizedLocation: "3195 KN 15",
      representative: "Danny van der Walle Goncalves",
      transportTerm: "PT216H"
    },
    status: {
      sendOnAta: false,
      sendDate: "2021-08-17T00:00:00Z",
      cancelInitiatedByCustoms: false,
      inspectionStatus: {
        type: "A3"
      }
    },
    timestamp: "2021-08-17T11:21:44.948Z"
  }
};

export const transitSendOnAta = <Transit>{
  summary: {
    crn: "ON_ATA_TEST",
    declarantShortName: "EIMSKIPBRR",
    consignmentNumbers: [],
    declarantFullName: "Eimskip Nederland B.V.",
    dischargeTerminalCode: "52090469",
    dischargeTerminalName: "Holland Amerikakade",
    departureOfficeCode: "NL000510",
    departureOfficeName: "NL000510",
    destinationsOfficeCode: "NL000510",
    destinationsOfficeName: "NL000510",
    typeCode: "T1",
    transportTerm: "PT216H",
    departureModeOfTransport: "ROAD_TRANSPORT",
    inspectionStatus: {
      type: "A3"
    },
    cancelInitiatedByCustoms: false,
    isInfoDeclared: false,
    hasMultipleHouseConsignments: false,
    isReleased: false,
    sendOnAta: true
  },
  hidden: false,
  isContainerDeclaration: false,
  isNewTransitDeclaration: false,
  selected: false,
  declaration: {
    declarantShortName: "EIMSKIPBRR",
    data: {
      dischargeTerminal: {
        terminalName: "Holland Amerikakade",
        terminalCode: "52090469"
      },
      emailAddressMrnToTerminal: "bladieblah@blah.nl",
      emailAddressesMrnToTerminalForCopy: ["typies@blah.nl"],
      emailAddressContainerInTransit: "hot@hotmail.com",
      emailAddressesContainerInTransitForCopy: ["bladieblah@blah.nl", "hot@hotmail.com"],
      emailAddressesForExpiryReminder: ["emailAddressesForExpiryReminder@blah.nl", "emailAddressesForExpiryReminder@hotmail.com"],
      expiryReminderNumberOfDaysBefore: 2,
      goodsItems: [
        {
          description: "SLAC 274 PC FISHING EQUIPMENT Ships stores in transhipment to final destination F/V Jonas at Mombasa Fisheries, Jetty, Liwatoni Fishing equipment",
          previousDocument: {
            type: {
              code: "N705",
              description: "oather"
            },
            documentNumber: "EIMUSKO130VESW009"
          },
          packageType: {
            code: "PK",
            name: "Package",
            bulk: false
          },
          marksAndNumbers: "Package",
          weight: 15000.0,
          numberOfPackages: 274
        }
      ],
      itinerary: [],
      type: {
        code: "T1",
        description: "T1"
      },
      countryOfExport: {
        code: "IS",
        name: "IS"
      },
      departureOffice: {
        name: "NL000510",
        unCode: "NL000510"
      },
      departureTransport: {
        modeOfTransport: "ROAD_TRANSPORT",
        nationality: {
          code: "NL",
          name: "NL"
        },
        reference: "TRUCK"
      },
      countryOfDestination: {
        code: "KE",
        name: "KE"
      },
      destinationsOffice: {
        name: "NL000510",
        unCode: "NL000510"
      },
      consignee: {
        eoriNumber: "NL807407343",
        name: "APM TERMINAL",
        address: "COLORADOWEG  50",
        zipCode: "3199 LA",
        city: "ROTTERDAM",
        countryCode: "NL"
      },
      transitOffices: [{
        name: "NL000511",
        unCode: "NL000511"
      }, {
        name: "NL000512",
        unCode: "NL000512"
      }, {
        name: "NL000513",
        unCode: "NL000513"
      }],
      guarantees: [{
        type: {
          code: "1",
          description: "Iets met een 1 erin"
        },
        customsValue: {
          amount: 123.45,
          currency: {
            unCode: "EUR",
            description: "Euris"
          }
        },
        country: {
          code: "NL",
          name: "Nederland"
        },
        guaranteeReferenceNumber: "GRUESOME",
        accessCode: "1244"
      }],
      seals: [
        "dichtjonghu"
      ],
      placeOfLoading: "3195 KN 15",
      authorizedLocation: "3195 KN 15",
      representative: "Danny van der Walle Goncalves",
      transportTerm: "PT216H"
    },
    status: {
      sendOnAta: true,
      cancelInitiatedByCustoms: false,
      inspectionStatus: {
        type: "A3"
      }
    },
    crn: "ON_ATA_TEST",
    timestamp: "2021-08-17T11:21:44.948Z"
  }
};

export const invalidGuarantee = <Transit>{
  summary: {
    crn: "INVALID_GUARANTEE",
    declarantShortName: "EIMSKIPBRR",
    containerNumber: "BEAU4085723",
    consignmentNumbers: [],
    declarantFullName: "Eimskip Nederland B.V.",
    departureOfficeCode: "NL000511",
    destinationsOfficeCode: "NL000511",
    typeCode: "T2",
    departureModeOfTransport: "INLAND_WATER_TRANSPORT",
    inspectionStatus: {
      type: "A3"
    },
    cancelInitiatedByCustoms: false,
    hasMultipleHouseConsignments: false,
    isInfoDeclared: false,
    isReleased: false,
    sendOnAta: true
  },
  hidden: false,
  isContainerDeclaration: true,
  isNewTransitDeclaration: false,
  selected: false,
  declaration: {
    declarantShortName: "EIMSKIPBRR",
    data: {
      containerNumber: "BEAU4085723",
      goodsItems: [
        {
          description: "CIGARETTES CAPITAL CIGARETTES",
          previousDocument: {
            type: {
              code: "Z-ZZZ"
            },
            documentNumber: "CMDUDXB0603652",
          },
          packageType: {
            code: "CS",
            name: "Case",
            bulk: false
          },
          marksAndNumbers: "CASE",
          weight: 16489,
          numberOfPackages: 1057
        }
      ],
      itinerary: [],
      type: {
        code: "T2"
      },
      countryOfExport: {
        code: "AE"
      },
      departureOffice: {
        unCode: "NL000511"
      },
      departureTransport: {
        modeOfTransport: "INLAND_WATER_TRANSPORT",
        nationality: {
          code: "DE"
        },
        reference: "BARGE"
      },
      countryOfDestination: {
        code: "PA"
      },
      destinationsOffice: {
        unCode: "NL000511"
      },
      consignee: {
        name: "ECT DELTA TERMINAL",
        address: "EUROPAWEG 875",
        zipCode: "3199LD",
        city: "ROTTERDAM",
        countryCode: "NL"
      },
      transitOffices: [{
        unCode: "NL000510"
      }],
      guarantees: [
        {
          type: {
            code: "6"
          },
          otherReference: "CODE 6",
          country: {
            code: "NL",
            name: "Netherlands"
          }
        }
      ],
      seals: ["939939"],
      placeOfLoading: "3199 KD 50",
      authorizedLocation: "3199 KD 50",
      representative: "WILLEM T HART"
    },
    status: {
      sendOnAta: true,
      cancelInitiatedByCustoms: false,
      inspectionStatus: {
        type: "A3"
      }
    },
    crn: "INVALID_GUARANTEE",
    timestamp: "2021-08-17T11:21:44.948Z"
  }
};

export const transitIcs2 = <Transit>{
  summary: {
    crn: "ICS2",
    declarantShortName: "EIMSKIPBRR",
    containerNumber: "ICS2",
    consignmentNumbers: [],
    declarantFullName: "Eimskip Nederland B.V.",
    departureOfficeCode: "NL000510",
    departureOfficeName: "Reeweg simplified proc.",
    destinationsOfficeCode: "NL000432",
    destinationsOfficeName: "Schiphol Cargo",
    typeCode: "T1",
    sendDate: "0001-01-01T00:00:00Z",
    transportTerm: "PT240H",
    departureModeOfTransport: "MARITIME_TRANSPORT",
    inspectionStatus: {
      type: "A3"
    },
    cancelInitiatedByCustoms: false,
    hasMultipleHouseConsignments: true,
    isInfoDeclared: false,
    isReleased: false,
    sendOnAta: false
  },
  hidden: false,
  isContainerDeclaration: true,
  isNewTransitDeclaration: false,
  selected: false,
  declaration: {
    crn: "ICS2",
    declarantShortName: "EIMSKIPBRR",
    data: {
      containerNumber: "ICS2",
      houseConsignments: [{
        goodsItems: [{
          description: "Europallets",
          previousDocument: {
            type: {
              code: "N714",
              description: "House-cognossement"
            },
            documentNumber: "1"
          },
          packageType: {
            code: "CN",
            name: "Container, not otherwise specified as transport equipment",
            bulk: false
          },
          marksAndNumbers: "1",
          weight: 1,
          numberOfPackages: 1,
          classification: {
            code: "73269040",
            description: "Pallets and similar platforms for handling goods"
          }
        }],
        transportDocuments: [{
          type: {
            code: "N714",
            description: "House bill of lading"
          },
          documentNumber: "1"
        }]
      }, {
        goodsItems: [{
          description: "Pleuropallets",
          previousDocument: {
            type: {
              code: "N714",
              description: "House-cognossement"
            },
            documentNumber: "2"
          },
          packageType: {
            code: "CN",
            name: "Container, not otherwise specified as transport equipment",
            bulk: false
          },
          marksAndNumbers: "2",
          weight: 1,
          numberOfPackages: 1,
          classification: {
            code: "44152020",
            description: "Flat pallets; pallet collars"
          }
        }, {
          description: "Zeuropallets",
          previousDocument: {
            type: {
              code: "N714",
              description: "House-cognossement"
            },
            documentNumber: "2"
          },
          packageType: {
            code: "CN",
            name: "Container, not otherwise specified as transport equipment",
            bulk: false
          },
          marksAndNumbers: "3",
          weight: 1,
          numberOfPackages: 1,
          classification: {
            code: "441520",
            description: "Pallets, box pallets and other load boards; pallet collars"
          }
        }],
        transportDocuments: [{
          type: {
            code: "N714",
            description: "House bill of lading"
          },
          documentNumber: "2"
        }]
      }],
      type: {
        code: "T1",
        description: "External Community Transit"
      },
      countryOfExport: {
        code: "CN",
        name: "China"
      },
      departureOffice: {
        unCode: "NL000510",
        name: "Reeweg simplified proc."
      },
      departureTransport: {
        reference: ".",
        nationality: {
          code: "BE",
          name: "Belgium"
        },
        modeOfTransport: "MARITIME_TRANSPORT"
      },
      countryOfDestination: {
        code: "NL",
        name: "Netherlands"
      },
      destinationsOffice: {
        unCode: "NL000432",
        name: "Schiphol Cargo"
      },
      borderTransport: {
        reference: ".",
        nationality: {
          code: "BE",
          name: "Belgium"
        },
        modeOfTransport: "MARITIME_TRANSPORT",
        customsOffice: {
          unCode: "NL000432",
          name: "Schiphol Cargo"
        }
      },
      consignor: {
        eoriNumber: "EORI",
        name: "Eimskip Nederland B.V.",
        address: "Port City I, Waalhaven Z.Z. 21",
        zipCode: "3089 JH",
        city: "Rotterdam",
        countryCode: "NL"
      },
      consignee: {
        ownerShortName: "CROSSOCEANRTM",
        zipCode: "1234 AA",
        address: "Test 123",
        city: "Rotterdam",
        countryCode: "NL",
        authorised: false,
        name: "Test Consignee",
        id: "Test Consignee",
        shortCode: "TEST"
      },
      declarantLicenseNumber: "12344",
      guarantees: [
        {
          guaranteeReferenceNumber: "24NL5634150000620",
          country: {
            code: "NL",
            name: "Netherlands"
          },
          customsValue: {
            amount: 1,
            currency: {
              unCode: "EUR",
              description: "Euro"
            }
          },
          accessCode: "9999",
          validFrom: "2024-09-30",
          type: {
            code: "1",
            description: "Comprehensive guarantee",
            grnRequired: true,
            referenceShouldBeSent: true,
            otherReferenceAllowed: false,
            otherReferenceRequired: false,
            withBalance: true
          }
        }
      ],
      seals: [
        "123"
      ],
      placeOfLoading: "1234 AB 5",
      authorizedLocation: "9876 ZB 5",
      transportTerm: "PT240H"
    },
    status: {
      sendOnAta: false,
      sendDate: "0001-01-01T00:00:00Z",
      cancelInitiatedByCustoms: false,
      inspectionStatus: {
        type: "A3"
      }
    }
  }
};

const matchingReleaseData = <TransitData>{
  containerNumber: "MSKU0608439",
  dischargeTerminal: {
    terminalName: "Holland Amerikakade",
    terminalCode: "52090469"
  },
  goodsItems: [
    {
      description: "SLAC 274 PC FISHING EQUIPMENT SHIPS STORES IN TRANSSHIPMENT TO FINAL DESTINATION F/V JONAS AT MOMBASA FISHERIES, JETTY, LIWATONI FISHING EQUIPMENT",
      previousDocument: {
        type: {
          code: "N705"
        },
        documentNumber: "EIMUSKO130VESW009"
      },
      packageType: {
        code: "PK",
        name: "Package",
        bulk: false
      },
      marksAndNumbers: "PACKAGE",
      weight: 15000,
      numberOfPackages: 274
    }
  ],
  itinerary: [],
  type: {
    code: "T1"
  },
  countryOfExport: {
    code: "IS"
  },
  departureOffice: {
    unCode: "NL000510"
  },
  departureTransport: {
    modeOfTransport: "ROAD_TRANSPORT",
    nationality: {
      code: "NL"
    },
    reference: "TRUCK"
  },
  countryOfDestination: {
    code: "KE"
  },
  destinationsOffice: {
    unCode: "NL000510"
  },
  consignee: {
    eoriNumber: "NL807407343",
    name: "APM TERMINAL",
    address: "COLORADOWEG 50",
    zipCode: "3199 LA",
    city: "ROTTERDAM",
    countryCode: "NL"
  },
  transitOffices: [],
  guarantees: [
    {
      type: {
        code: "0",
        description: "Guarantee waiver",
        grnRequired: true,
        referenceShouldBeSent: true,
        otherReferenceAllowed: false,
        otherReferenceRequired: false,
        withBalance: true
      },
      accessCode: "6231",
      guaranteeReferenceNumber: "12NL5663790002NM3"
    }
  ],
  seals: [
    "939939"
  ],
  placeOfLoading: "3195 KN 15",
  representative: "DANNY VAN DER WALLE GONCALVES"
};

const misMatchingReleaseData = <TransitData>{
  containerNumber: "BEAU4085723",
  goodsItems: [
    {
      description: "CIGARETTES CAPITAL CIGARETTES",
      previousDocument: {
        type: {
          code: "Z-ZZZ"
        },
        documentNumber: "CMDUDXB0603652",
      },
      packageType: {
        code: "CS",
        name: "Case",
        bulk: false
      },
      marksAndNumbers: "CASE",
      weight: 16489,
      numberOfPackages: 1057
    }
  ],
  itinerary: [],
  type: {
    code: "T2"
  },
  countryOfExport: {
    code: "AE"
  },
  departureOffice: {
    unCode: "NL000511"
  },
  departureTransport: {
    modeOfTransport: "INLAND_WATER_TRANSPORT",
    nationality: {
      code: "DE"
    },
    reference: "BARGE"
  },
  countryOfDestination: {
    code: "PA"
  },
  destinationsOffice: {
    "unCode": "NL000511"
  },
  consignee: {
    name: "ECT DELTA TERMINAL",
    address: "EUROPAWEG 875",
    zipCode: "3199LD",
    city: "ROTTERDAM",
    countryCode: "NL"
  },
  transitOffices: [{
    unCode: "NL000510"
  }],
  guarantees: [
    {
      type: {
        code: "R",
        description: "Guarantee not required for goods carried on the Rhine or Danube",
        grnRequired: false,
        referenceShouldBeSent: false,
        otherReferenceAllowed: false,
        otherReferenceRequired: false,
        withBalance: false
      }
    }
  ],
  seals: ["939939"],
  placeOfLoading: "3199 KD 50",
  authorizedLocation: "3199 KD 50",
  representative: "WILLEM T HART"
};

function saved(input: Transit) {
  const object = cloneDeclaration(input);

  object.summary.phase = TransitPhase.undeclared;

  return object;
}

function declared(input: Transit) {
  const object = cloneDeclaration(input);

  object.summary.phase = TransitPhase.declared;

  return object;
}

function send(input: Transit) {
  const object = cloneDeclaration(input);
  const sentDate = "2021-08-24";

  object.summary.phase = TransitPhase.sent;
  object.summary.sentDate = sentDate;

  object.declaration.status.sent = <TransitStatusUpdate>{processId: "1", date: sentDate};

  return object;
}

function accept(input: Transit) {
  const object = cloneDeclaration(send(input));
  const mrn = "11NL5665111001F4C1";

  object.summary.phase = TransitPhase.accepted;
  object.summary.mrn = mrn;

  object.declaration.status.accept = <TransitStatusUpdate>{processId: "1", date: "2021-08-24"};
  object.declaration.status.mrn = mrn;

  return object;
}

function reject(input: Transit) {
  const object = cloneDeclaration(send(input));

  object.summary.phase = TransitPhase.rejected;

  object.declaration.status.reject = <TransitStatusUpdate>{
    processId: "1",
    date: "2021-08-24",
    reason: "We rejected your transit ha!"
  };

  return object;
}

function release(input: Transit) {
  const object = cloneDeclaration(accept(input));
  const transportExpiryDate = "2022-02-18";
  const inspectionStatus = <TransitInspectionStatus>{
    "type": "A3",
    "inspectionDate": "2021-09-27T12:00:00Z",
    "inspectionExpiryDate": transportExpiryDate,
    "inspectorName": "NOT CONTROLLED",
    "bindingItinerary": true,
    "authorisationNumber": "NL00740014170"
  };

  object.summary.phase = TransitPhase.inTransit;
  object.summary.isReleased = true;
  object.summary.transportExpiryDate = transportExpiryDate;
  object.summary.inspectionStatus = inspectionStatus;

  object.declaration.status.release = <TransitStatusUpdate>{processId: "1", date: "2021-08-24"};
  object.declaration.transportExpiryDate = transportExpiryDate;
  object.declaration.dataFromCustoms = matchingReleaseData;
  object.declaration.status.inspectionStatus = inspectionStatus;

  return object;
}

function releaseMismatching(input: Transit) {
  const object = cloneDeclaration(accept(input));

  object.summary.phase = TransitPhase.inTransit;
  object.summary.isReleased = true;

  object.declaration.status.release = <TransitStatusUpdate>{processId: "1", date: "2021-08-24"};
  object.declaration.dataFromCustoms = misMatchingReleaseData;

  return object;
}

function arrive(input: Transit) {
  const object = cloneDeclaration(release(input));
  const actualDestinationCode = "BE424000";

  object.summary.phase = TransitPhase.arrived;
  object.summary.actualDestinationCode = actualDestinationCode;

  object.declaration.status.arrival = <TransitStatusUpdate>{processId: "1", date: "2021-08-24"};
  object.declaration.status.actualDestinationCode = actualDestinationCode;

  return object;
}

function writeoff(input: Transit) {
  const clearanceCode = "0";
  const object = cloneDeclaration(arrive(input));

  object.summary.phase = TransitPhase.writtenOff;
  object.summary.clearanceCode = clearanceCode;

  object.declaration.status.writeOff = <TransitStatusUpdate>{processId: "1", date: "2021-08-24"};
  object.declaration.status.clearanceCode = clearanceCode;

  return object;
}

function cancelled(input: Transit) {
  const object = cancelrequested(input);

  object.summary.phase = TransitPhase.cancelled;

  object.declaration.status.cancellation = <TransitStatusUpdate>{
    processId: "1",
    date: "2021-08-24",
    reason: "We cancelled your transit ha!"
  };

  return object;
}

function cancelledByCustoms(input: Transit) {
  const object = cancelled(input);

  object.summary.cancelInitiatedByCustoms = true;

  object.declaration.status.cancelInitiatedByCustoms = true;

  return object;
}

function notreleased(input: Transit) {
  const object = cloneDeclaration(accept(input));

  object.summary.phase = TransitPhase.releaseRejected;

  object.declaration.status.releaseRejected = <TransitStatusUpdate>{
    processId: "1", date: "2021-08-24",
    reason: "We rejected the release of your transit ha!"
  };

  return object;
}

function inspection(input: Transit) {
  const object = cloneDeclaration(accept(input));

  object.summary.phase = TransitPhase.inspection;

  object.declaration.status.controlNotification = <TransitStatusUpdate>{processId: "1", date: "2021-08-24"};

  return object;
}

function insufficientguarantee(input: Transit) {
  const object = cloneDeclaration(accept(input));

  object.summary.phase = TransitPhase.insufficientGuarantee;

  object.declaration.status.insufficientGuarantee = <TransitStatusUpdate>{
    processId: "1", date: "2021-08-24",
    reason: "Guarantee 12NL5663790002NM3-AA: not enough. Guarantee 12NL5663790002NM3-AB: not enough too"
  };

  return object;
}

function cancelrequested(input: Transit) {
  const object = cloneDeclaration(input);

  object.summary.phase = TransitPhase.cancellationRequested;

  object.declaration.status.cancellationRequest = <TransitStatusUpdate>{processId: "1", date: "2021-08-24"};

  return object;
}

function inforequested(input: Transit) {
  const object = cloneDeclaration(release(input));
  const investigatingOffice = "ABC";
  const infoRequestExpirationDate = "2021-09-27T12:00:00Z";

  object.summary.phase = TransitPhase.proofOfArrivalRequested;
  object.summary.investigatingOffice = investigatingOffice;
  object.summary.infoRequestExpirationDate = infoRequestExpirationDate;

  object.declaration.status.infoRequest = <TransitStatusUpdate>{processId: "1", date: "2021-08-24"};
  object.declaration.status.investigatingOffice = investigatingOffice;
  object.declaration.status.infoRequestExpirationDate = infoRequestExpirationDate;

  return object;
}

function infodeclared(input: Transit) {
  const object = cloneDeclaration(inforequested(input));

  object.summary.phase = TransitPhase.proofOfArrivalSent;
  object.summary.isInfoDeclared = true;

  object.declaration.status.infoDeclared = <TransitStatusUpdate>{processId: "1", date: "2021-08-24"};

  return object;
}

function mrnDeclared(input: Transit) {
  const object = cloneDeclaration(input);

  object.declaration.status.mrnDeclaration = <TransitStatusUpdate>{processId: "1", date: "2021-08-24"};

  return object;
}

function mrnSent(input: Transit) {
  const object = cloneDeclaration(input);
  const sentDate = "2021-08-25";

  object.summary.phase = TransitPhase.inTransitMrnSent;
  object.summary.mrnSentDate = sentDate;

  object.declaration.status.mrnSent = <TransitStatusUpdate>{processId: "1", date: sentDate};

  return object;
}

function mrnAccepted(input: Transit) {
  const object = cloneDeclaration(input);
  const acceptDate = "2021-08-26";

  object.summary.phase = TransitPhase.inTransitMrnAccepted;
  object.summary.mrnAcceptDate = acceptDate;

  object.declaration.status.mrnAccept = <TransitStatusUpdate>{processId: "1", date: acceptDate};

  return object;
}

function mrnRejected(input: Transit) {
  const object = cloneDeclaration(input);
  const rejectDate = "2021-08-26";
  const rejectReason = "kannie he!!";

  object.summary.phase = TransitPhase.inTransitMrnRejected;
  object.summary.mrnRejectDate = rejectDate;
  object.summary.mrnRejectReason = rejectReason;

  object.declaration.status.mrnReject = <TransitStatusUpdate>{processId: "1", date: rejectDate, reason: rejectReason};

  return object;
}

function cloneDeclaration(input: Transit): Transit {
  const result = cloneObject(input);
  const lrn = uuid();

  result.summary.lrn = lrn;
  result.declaration.lrn = lrn;

  return result;
}

function store(transit: Transit): TransitSummary {
  transitMap.set(transit.declaration.lrn, transit.declaration);

  return transit.summary;
}

export const transitMap = new Map<String, TransitDeclaration>();

export const transitSummaries = [
  store(saved(simplifiedScheduled)),
  store(accept(simplifiedScheduled)),
  store(release(simplifiedScheduled)),
  store(saved(simplifiedOnAta)),
  store(accept(simplifiedOnAta)),
  store(release(simplifiedOnAta)),
  store(saved(simplifiedDirectly)),
  store(accept(simplifiedDirectly)),
  store(release(simplifiedDirectly)),
  store(declared(transitWithCrn)),
  store(declared(transitWithoutCrn)),
  store(saved(transitWithoutCrn)),
  store(declared(invalidGuarantee)),
  store(send(transitWithoutCrn)),
  store(declared(transitSendOnAta)),
  store(send(transitSendOnAta)),
  store(accept(transitWithoutCrn)),
  store(accept(transitDepartureTransportModeNotSpecified)),
  store(reject(transitWithoutCrn)),
  store(release(transitWithoutCrn)),
  store(releaseMismatching(transitWithoutCrn)),
  store(arrive(transitWithoutCrn)),
  store(writeoff(transitWithoutCrn)),
  store(cancelled(transitWithCrn)),
  store(cancelled(accept(transitWithoutCrn))),
  store(cancelled(send(transitWithoutCrn))),
  store(cancelled(accept(transitCancelledAcceptedFound))),
  store(cancelrequested(accept(transitWithoutCrn))),
  store(cancelledByCustoms(accept(transitWithoutCrn))),
  store(notreleased(transitWithoutCrn)),
  store(inspection(transitWithoutCrn)),
  store(insufficientguarantee(transitWithoutCrn)),
  store(inforequested(transitWithoutCrn)),
  store(infodeclared(transitWithoutCrn)),
  store(mrnDeclared(release(transitWithoutCrn))),
  store(mrnDeclared(infodeclared(transitWithoutCrn))),
  store(mrnSent(mrnDeclared(release(transitWithoutCrn)))),
  store(mrnAccepted(mrnSent(mrnDeclared(release(transitWithoutCrn))))),
  store(mrnRejected(mrnSent(mrnDeclared(release(transitWithoutCrn))))),
  store(saved(transitIcs2)),
];
